import { render, staticRenderFns } from "./MetaDataCreate.vue?vue&type=template&id=4ded36cd&"
import script from "./MetaDataCreate.vue?vue&type=script&lang=js&"
export * from "./MetaDataCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports